import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AtomModalWrapperModule } from '../../../components/atoms/atom-modal-wrapper/atom-modal-wrapper.module';
import { MoleculeSearchBarModule } from '../../../components/molecules/molecule-search-bar/molecule-search-bar.module';
import { OrganismModalModule } from '../../../components/organisms/organism-modal/organism-modal.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { HybridSelectMenuModule } from '../../../shared/components/hybrid-select-menu';
import { FormFiltersModule } from '../../../shared/features/form-filters/form-filters.module';
import { QueryBuilderFilterHandlerService } from '../../../shared/features/form-filters/shared/services/filter-handler/filter-handler.service';
import { FilterQueryService } from '../../../shared/features/form-filters/shared/services/filter-query';
import { MoleculeSearchAndFilterBarComponent } from './molecule-search-and-filter-bar.component';
@NgModule({
    imports: [
        AtomModalWrapperModule,
        CommonModule,
        DirectivesModule,
        FormFiltersModule,
        MoleculeSearchBarModule,
        OrganismModalModule,
        PipesModule,
        RouterModule,
        HybridSelectMenuModule,
    ],
    declarations: [MoleculeSearchAndFilterBarComponent],
    exports: [MoleculeSearchAndFilterBarComponent],
    providers: [FilterQueryService, QueryBuilderFilterHandlerService],
})
export class MoleculeSearchAndFilterBarModule {}
